import { Injectable } from '@angular/core'
import { ToastButton } from '@ionic/angular'
import { BehaviorSubject } from 'rxjs'

import { TOAST_STATE } from './types/toast.type'

@Injectable({
	providedIn: 'root',
})
export class ToastService {
	public showsToast$ = new BehaviorSubject<boolean>(false)

	public toastMessage$ = new BehaviorSubject<string>('')

	public toastState$ = new BehaviorSubject<string>(TOAST_STATE.MEDIUM)

	public toastButtons$ = new BehaviorSubject<ToastButton[]>([])

	showToast(toastState: TOAST_STATE, toastMessage: string, toastButtons: ToastButton[] = []): void {
		// To dismiss an already being shown toast
		this.dismissToast()

		// This will update the toastState to the toastState passed into the function
		this.toastState$.next(toastState)

		// This updates the toastMessage to the toastMsg passed into the function
		this.toastMessage$.next(toastMessage)

		// This will update the showsToast trigger to 'true'
		this.showsToast$.next(true)

		// This will update the list of buttons to show on the toast
		this.toastButtons$.next(toastButtons)
	}

	// This updates the showsToast behaviour subject to 'false'
	dismissToast(): void {
		this.showsToast$.next(false)
	}
}
